import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthTokensService } from '../../../web/modern/auth-tokens.service';

@Injectable()
export class HttpServiceProvider {
	constructor(
		private http: HttpClient,
		private tokenService: AuthTokensService
	) {}

	authorizedPost(url: string, data): Observable<Object> {
		const token = this.tokenService.getAuthToken();

		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`
		});
		const options = { headers };

		return this.http.post(url, data, options);
	}

	fileUploadPost(url: string, data): Observable<Object> {
		const token = this.tokenService.getAuthToken();
		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`
		});
		const options = { headers };
		return this.http.post(url, data, options);
	}

	editMediaGet(url: string): Observable<Object> {
		const token = this.tokenService.getAuthToken();
		const headers = new HttpHeaders({
			Authorization: `Bearer ${token}`
		});
		const options = { headers };
		return this.http.get(url, options);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/helpers/http.service.ts